module.exports = __webpack_public_path__ + "static/media/0023_IMG_LES_MURS_TRUFFLE_W_VTR2100_CHEVRON.32c74363.png";